import { useEffect, useState } from "react";
import React from "react";
import { SectionWrapper } from "../../hoc";

import "./Protocols.css";
// import the separated file related to the component
import TextProtocols from "./TextProtocols";
import { RingLoader } from "react-spinners";
import { scrollToId } from "../../utils/scrollToId";
const Protocols = ({setDisplayNavBar}) => {
  const [loading, setLoading] = useState(true)
  
  useEffect(() => {    // Simulate a delay (remove this in your actual implementation)
    setTimeout(() => {
      setLoading(false); // Set loading to false after a delay
    }, 2000); // Simulated delay of 2 seconds

    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    setDisplayNavBar(!loading)
    if(!loading){
      scrollToId()
    }
  }, [loading, setDisplayNavBar])
  return (
    <>
      {/* Display the content of the page on the entire viewport */}
      <div className="full-viewport relative">
       {loading ? (<div className="spinner-container fixed h-screen w-screen bg-white z-10">
          <RingLoader color="#BA55D3" loading={loading} />{" "}
          <script>{document.body.style.overflow = 'hidden'}</script>
        </div>): <script>{document.body.style.overflow = 'auto'}</script>}
      <> 
        {/* Set the size and crop the image on top of the page */}
        <div className="top-page">
          <h1>Protocols</h1>
        </div>
        {/* divide the section in columns */}
        <div
          className="grid grid-cols-12 gap-4"
          style={{ marginRight: "50px", marginLeft: "70px" }}
        >
          <main className="prose col-span-12 order-1 md:order-2">
            {/* main content which is a separated file you call and it is displayed on the right of the section above */}
            <TextProtocols />
          </main>
        </div>
       </></div>
    </>
  );
};

// don't forget to change the name of the component you're exporting
export default SectionWrapper(Protocols, "Protocols");
